export const ENVIRONMENT = {
  REQUEST_URL: '',
  WS_URL: process.env.REACT_APP_BASE_URL,
  BASE_URL: process.env.REACT_APP_BASE_URL,
}
